import React, { useState } from 'react';
import './SettingsContent.scss';

import Toggle from '../../Elements/Toggle';
import { toastr } from 'react-redux-toastr';

export default (props) => {
  const { bot, updateBotIaStatus, user } = props;

  const [selected, setSelected] = useState(bot.iaStatus);

  const handleSwitch = () => {
    setSelected(!selected);
  };
  const handleSaveBot = () => {
    if (bot.iaEnabled === false) {
      toastr.warning('Para utilizar este recurso é necessário ativar a IA.');
    }
    updateBotIaStatus(bot._id, selected);
  };

  return (
    <div className="ia-wrapper">
      <div className="title">
        <span>Configuração de Criador</span>
        <strong>IA</strong>
      </div>
      <span>Configure o comportamento da IA nos blocos.</span>
      <div className="enable-ia">
        <Toggle
          disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
          checked={selected}
          onChange={() => {
            handleSwitch();
          }}
        />
        <label>IA ativa em todos os blocos por padrão</label>
      </div>
      <button
        disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
        onClick={() => handleSaveBot()}
        type="submit"
      >
        salvar
      </button>
    </div>
  );
};
